// extracted by mini-css-extract-plugin
export default {"sectionTitle":"sharedForm-module--section-title--3C-lR","part":"sharedForm-module--part--55sZm","hidden":"sharedForm-module--hidden--1bBaV"};